import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * A plain `approver` may ONLY use the approvals queue. Any other Studio route
 * (create / agents / abilities / agent detail / wizard) redirects to
 * /agents/approvals, so the rest of Studio is effectively hidden for them — this
 * is the route-level backstop for the nav tabs hidden in the shell. Because the
 * default redirect lands on /create (which carries this guard), an approver who
 * opens Studio is taken straight to the approvals queue.
 *
 * Non-approver roles pass through untouched; studioGuard already gates whether a
 * role may enter Studio at all. Role is read from the same source as studioGuard.
 */
export const approverGuard: CanActivateFn = () => {
  const role = (sessionStorage.getItem('current-role') ?? '').toLowerCase();
  if (role !== 'approver') return true;
  inject(Router).navigate(['/agents/approvals']);
  return false;
};
